document.addEventListener('DOMContentLoaded', function() {
    const productType = document.querySelector('.dimensions-wrapper').closest('[data-product-type]')?.dataset.productType;
    
    // Only execute this code block for mattress products
    console.log('Product Type:', productType);
    
    if (productType === 'Bedding') {
        const widthSelect = document.querySelector('#width');
        const widthFieldset = document.querySelector('[data-handle="width"]');
        
        console.log('Width Select:', widthSelect);
        console.log('Width Fieldset:', widthFieldset);

        function getBeddingVariant(width) {
            if (width >= 20 && width <= 30) return '20-30W';
            if (width >= 31 && width <= 41) return '31-41W';
            if (width >= 42 && width <= 47) return '42-47W';
            if (width >= 48 && width <= 66) return '48-66W';
            if (width >= 67 && width <= 76) return '67-76W';
            if (width >= 77 && width <= 80) return '77-80W';
            return null;
        }

        function updateSelectedVariant() {
            const width = parseInt(widthSelect.value, 10);
            let selectedOption = getBeddingVariant(width);
            console.log('Selected option:', selectedOption);

            if (selectedOption) {
                // Find all radio inputs within the fieldset
                const radioInputs = widthFieldset.querySelectorAll('input[type="radio"]');
                let optionFound = false;

                // Loop through radio buttons to find and select the matching one
                radioInputs.forEach(radio => {
                    if (radio.value === selectedOption) {
                        radio.checked = true;
                        const event = new Event('change', { bubbles: true });
                        radio.dispatchEvent(event);
                        optionFound = true;
                    }
                });

                if (!optionFound) {
                    console.log('No matching option found');
                }
            }
        }

        if (widthSelect) {
            widthSelect.addEventListener('change', updateSelectedVariant);
        }
    }
});